<dt-modal-content size="big" (closeClick)="close()" [flexContent]="false" [contentPadding]="true">
  <ng-template #title
    ><span i18n>Qualitätskriterium</span>: <span> {{ criteriaToExplain }}</span></ng-template
  >
  <ng-template #content>
    <h3> {{ criteriaToExplain }}</h3>
    @for (contentFragment of explanation.content; track contentFragment) {
      <p> {{ contentFragment }} </p>
    }
    <div class="bar-wrapper">
      <div class="bar-container">
        <dt-bar-slider
          [(value)]="criteriaValue"
          [interval]="false"
          [vertical]="false"
          [disabledLook]="false"
          [width]="21"
          [min]="0"
          [max]="10"
          [step]="0.01"
          [topLabels]="topLabels"
          [showBottomLabels]="true"
          (valueChange)="forwardValueChange($event)"
          [disabled]="decisionDataState.isProjectReadonly"
        ></dt-bar-slider>
      </div>
    </div>
  </ng-template>
  <ng-template #footer>
    @if (allowRevise) {
      <button mat-raised-button [color]="criteriaValue >= 8 ? 'accent-less' : 'accent'" (click)="revise()">{{
        explanation.reviseButtonText
      }}</button>
    }
    <button
      mat-raised-button
      [color]="criteriaValue < 8 || !(explanation.reviseButtonText != null && allowRevise) ? 'accent-less' : 'accent'"
      (click)="close()"
      i18n
      >Schließen</button
    >
  </ng-template>
</dt-modal-content>
